import { Route, Routes, Navigate } from "react-router-dom"
import React from "react"
import { Fragment } from "react"
import "./styles/App.scss"

// Layouts
import AdminLayout from "./components/layouts/AdminLayout"
import UserJobsLayout from "./pages/users/JobsList/UserJobsLayout"
import PublicLayout from "./components/layouts/PublicLayout"

// Authentucation
import LoginRedirectPage from "./pages/auth/sign_in/LoginRedirectPage"
import ProtectedRoute from "./components/common/ProtectedRoute"
import SignIn from "./pages/auth/sign_in/SignIn"
import SignUp from "./pages/auth/sign_up/SignUp"
import ForgotPassword from "./pages/auth/forgot-password/ForgotPassword"

// Error Page
import NotFound from "./pages/ErrorPage/NotFound/NotFound"
import UnauthorizedError from "./pages/ErrorPage/NotAuthorized/UnauthorizedError"
import ForbiddenError from "./pages/ErrorPage/Forbidden/ForbiddenError"
import InternalServerError from "./pages/ErrorPage/InternalServerError/InternalServerError"
import SystemMaintenance from "./pages/ErrorPage/SystemMaintenance/SystemMaintenance"

// Member - Application Form
import AppFormPage from "./pages/users/AppFormPage/AppFormPage"
import JobFormPage from "./pages/users/AppFormPage/JobFormPage"

// Member - Detail Open Job
import UserJobDetail from "./pages/users/JobsList/UserJobDetail"

// Admin - Master Data: Users
// import Users from "./pages/admin/master-user/Users"
// import CreateUser from "./pages/admin/master-user/CreateUser"
// import EditUser from "./pages/admin/master-user/EditUser"
// import EditEmp from "./pages/admin/master-user/EditEmp"

// // Admin - Master Data: Roles
// import Roles from "./pages/admin/master-role/Roles"
// import CreateRole from "./pages/admin/master-role/CreateRole"
// import EditRole from "./pages/admin/master-role/EditRole"

// // Admin - Master Data: Status
// import Status from "./pages/admin/master-status/Status"
// import EditStatus from "./pages/admin/master-status/EditStatus"

// // Admin - Master Data: Sites
// import Sites from "./pages/admin/master-site/Sites"
// import EditSite from "./pages/admin/master-site/EditSite"
// import CreateSite from "./pages/admin/master-site/CreateSite"

// // Admin - Master Data: PDPA
import PDPAs from "./pages/admin/master-pdpa/PDPA"
import PDPAUserPaging from "./pages/admin/master-pdpa/PDPAUserPaging"
import CreatePDPAEdit from "./pages/admin/master-pdpa/CreatePDPA-edit"
// import SettlementConsentPage from "./pages/users/settlement-consent/page"

// HR - Jobs Hiring
import JobCreate from "./pages/admin/job-hiring/JobCreate"
import JobLists from "./pages/admin/job-hiring/JobLists"
import JobDetail from "./pages/admin/job-hiring/JobDetail"
import JobEdit from "./pages/admin/job-hiring/JobEdit"
import JobHistory from "./pages/admin/job-hiring/JobHistory"

// HR - All Submitted Application Form
// import SubmittedForm from "./pages/admin/submitted-form/SubmittedForm"
import SubmittedFormPaging from "./pages/admin/submitted-form/SubmittedFormPaging"
import JobAppDetail from "./pages/admin/submitted-form/JobAppDetail"
import StatusDescription from "./pages/admin/submitted-form/StatusDes"

// HR - Interview Appointment
import AppointmentList from "./pages/admin/interview/AppointmentList"

import Dashboard from "./pages/admin/dashboard/Dashboard"

import JobStatus from "./pages/users/JobsStatus/JobsStatus"
import AppformDetail from "./pages/users/JobsStatus/AppformDetail"

import DataToECPaging from "./pages/admin/ec-data/DataToECPaging"
import UploadExcel from "./pages/admin/hiring-upload/UploadExcel"

import ExcelToECPaging from "./pages/admin/ec-excel-data/ExcelToECPaging"
import ExcelEcDetail from "./pages/admin/ec-excel-data/ExcelEcDetail"

import EmployeeContract from "./pages/admin/employee-contract/EmployeeContract"
import AddEmployeeContract from "./pages/admin/employee-contract/AddEmployeeContract"
import EditEmployeeContract from "./pages/admin/employee-contract/EditEmployeeContract"

// Admin - Master Data: Users
import Users from "./pages/admin/master-user/Users"
import CreateUser from "./pages/admin/master-user/CreateUser"
import EditUser from "./pages/admin/master-user/EditUser"
import EditEmp from "./pages/admin/master-user/EditEmp"

// Admin - Master Data: Roles
import Roles from "./pages/admin/master-role/Roles"
import CreateRole from "./pages/admin/master-role/CreateRole"
import EditRole from "./pages/admin/master-role/EditRole"

// Admin - Master Data: Status
import Status from "./pages/admin/master-status/Status"
import EditStatus from "./pages/admin/master-status/EditStatus"

// Admin - Master Data: Sites
import Sites from "./pages/admin/master-site/Sites"
import EditSite from "./pages/admin/master-site/EditSite"
import CreateSite from "./pages/admin/master-site/CreateSite"

// import dayjs, { Dayjs } from "dayjs"

// Support - Master Data: Menutus
import Menus from './pages/support/master-menu/Menus';
// import Menus from './pages/support/master-menu/CreateMenu';
import ManageMenu from './pages/support/master-menu/ManageMenu';

import Bank from './pages/support/master-bank/Bank';
import ManageBank from "./pages/support/master-bank/ManageBank"

import Company from "./pages/support/master-company/Company"
import ManageCompany from "./pages/support/master-company/ManageCompany"

import Country from "./pages/support/master-country/Country-update"
import ManageCountry from "./pages/support/master-country/ManageCountry-update"

import CountryOfNationalId from "./pages/support/master-country-of-nationalId/CountryOfNationalId"
import ManageCountryOfNationalId from "./pages/support/master-country-of-nationalId/ManageCountryOfNationalId"

import Religion from "./pages/support/master-religion/Religion-update"
import ManageReligion from "./pages/support/master-religion/ManageReligion-update"

import MaritalStatus from "./pages/support/master-marital-starus/MaritalStatus"
import ManageMaritalStatus from "./pages/support/master-marital-starus/ManageMaritalStatus"

import Prefix from "./pages/support/master-prefix/Prefix"
import ManagePrefix from "./pages/support/master-prefix/ManagePrefix"

import IncentiveGroup from "./pages/support/master-incentive-group/IncentiveGroup"
import ManageIncentiveGroup from "./pages/support/master-incentive-group/ManageIncentiveGroup"

import ONBHolidaySchedule from "./pages/support/master-ONB-holiday-schedule/ONBHolidaySchedule"
import ManageONBHolidaySchedule from "./pages/support/master-ONB-holiday-schedule/ManageONBHolidaySchedule"

import ONBSchedule from "./pages/support/master-ONB-schedule/ONBSchedule"
import ManageONBSchedule from "./pages/support/master-ONB-schedule/ManageONBSchedule"

import PayGrade from "./pages/support/master-pay-grade/PayGrade"
import ManagePayGrade from "./pages/support/master-pay-grade/ManagePayGrade"

import PayGroup from "./pages/support/master-pay-group/PayGroup"
import ManagePayGroup from "./pages/support/master-pay-group/ManagePayGroup"

import SSOHospital from "./pages/support/master-sso-hospital/SSOHospital-update"
import ManageSSOHospital from "./pages/support/master-sso-hospital/ManageSSOHospital-update"

import WorkGroup from "./pages/support/master-work-group/WorkGroup-update"
import ManageWorkGroup from "./pages/support/master-work-group/ManageWorkGroup-update"

import OTP from "./pages/support/master-otp/OTP"
// import StatusTimeLog from "./pages/support/master-time-log/StatusTimeLog"

import ExcelToECPagingSupport from "./pages/support/master-ec/ExcelToECPaging"
import DataToECPagingSupport from "./pages/support/master-ec/DataToECPaging"

enum MENU_ID {
  DASHBOARD = "101",
  JOBS_LIST = "201",
  JOBS_CREATE = "202",
  JOBS_HISTORY = "203",
  SUBMITTED_FORM = "301",
  APPOINTMENT = "401",
  DATA_TO_EC = "501",
  USERS = "601",
  ROLES = "602",
  SITES = "603",
  STATUS = "604",
  MENUS = "605",
  COMPANY = "709",
  Bank = "708",
  // PDPA = "606",
  // PDPA = "606",
  EXCEL = "801",
  CONTRACT = "901",
  PDPA = "1001",
}

const currentDate = new Date()
const startDate = new Date("2025-04-14T00:00:00") // April 14, 2025, 12:00 AM
const endDate = new Date("2025-04-15T00:00:00") // April 15, 2025, 6:00 AM

function App() {
  if (currentDate >= startDate && currentDate <= endDate) {
    return (
      <Routes>
        <Route path="/system-maintenance" element={<SystemMaintenance />} />
        <Route
          path="*"
          element={<Navigate to="/system-maintenance" replace />}
        />
      </Routes>
    )
  }

  return (
    <Fragment>
      <Routes>
        <Route path="/" element={<PublicLayout />}>
          <Route index element={<UserJobsLayout />} />
          <Route path="/login/:id?" element={<SignIn />} />
          <Route path="/register" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          <Route path="jobs">
            <Route index element={<UserJobsLayout />} />
            <Route path="detail/:id" element={<UserJobDetail />} />
          </Route>
          <Route path="/appform" element={<AppFormPage />} />
          <Route path="/job-form" element={<JobFormPage />} />
          <Route path="jobs_status">
            <Route index element={<JobStatus />} />
            <Route path="appformdetail/:id" element={<AppformDetail />} />
          </Route>
        </Route>
        {/* --------------------------------------------- admin ------------------------------------ */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute allowedRoles={["HR Recruiter", "Super Admin"]}>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route
            index
            element={
              <ProtectedRoute requiredMenus="101">
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="dashboard"
            element={
              <ProtectedRoute requiredMenus="101">
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path="jobs">
            <Route
              index
              element={
                <ProtectedRoute requiredMenus={MENU_ID.JOBS_LIST}>
                  <JobLists />
                </ProtectedRoute>
              }
            />
            <Route
              path="detail/:id"
              element={
                <ProtectedRoute requiredMenus={MENU_ID.JOBS_LIST}>
                  <JobDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="create"
              element={
                <ProtectedRoute requiredMenus={MENU_ID.JOBS_CREATE}>
                  <JobCreate />
                </ProtectedRoute>
              }
            />
            <Route
              path="edit/:id"
              element={
                <ProtectedRoute requiredMenus={MENU_ID.JOBS_LIST}>
                  <JobEdit />
                </ProtectedRoute>
              }
            />
            <Route
              path="history"
              element={
                <ProtectedRoute requiredMenus={MENU_ID.JOBS_HISTORY}>
                  <JobHistory />
                </ProtectedRoute>
              }
            />
          </Route>
          <Route path="interview">
            <Route
              path="schedule"
              element={
                <ProtectedRoute requiredMenus={MENU_ID.APPOINTMENT}>
                  <AppointmentList />
                </ProtectedRoute>
              }
            />
          </Route>
          <Route path="application-form">
            <Route
              index
              element={
                <ProtectedRoute requiredMenus={MENU_ID.SUBMITTED_FORM}>
                  <SubmittedFormPaging />
                </ProtectedRoute>
              }
            />
            <Route path="status-description" element={<StatusDescription />} />
            <Route
              path="detail/:id"
              element={
                <ProtectedRoute requiredMenus={MENU_ID.SUBMITTED_FORM}>
                  <JobAppDetail />
                </ProtectedRoute>
              }
            />
          </Route>
          <Route path="hiring">
            <Route path="upload">
              <Route
                index
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.DATA_TO_EC}>
                    <UploadExcel />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="ec">
              <Route
                index
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.EXCEL}>
                    <ExcelToECPaging />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="detail/:id/:type"
              element={
                <ProtectedRoute requiredMenus={MENU_ID.SUBMITTED_FORM}>
                  <ExcelEcDetail />
                </ProtectedRoute>
              }
            />
          </Route>
          <Route path="ec">
            <Route path="data">
              <Route
                index
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.DATA_TO_EC}>
                    <DataToECPaging />
                  </ProtectedRoute>
                }
              />
              <Route
                path="detail/:id"
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.DATA_TO_EC}>
                    <DataToECPaging />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Route>
          <Route path="pdpa">
            <Route index element={<Navigate to="upload" replace />} />
            <Route path="upload">
              <Route
                index
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.PDPA}>
                    <PDPAs />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="user">
              <Route
                index
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.PDPA}>
                    <PDPAUserPaging />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="edit/:id"
              element={
                <ProtectedRoute requiredMenus={MENU_ID.PDPA}>
                  <CreatePDPAEdit type="edit" />
                </ProtectedRoute>
              }
            />
            <Route
              path="create"
              element={
                <ProtectedRoute requiredMenus={MENU_ID.PDPA}>
                  <CreatePDPAEdit type="add" />
                </ProtectedRoute>
              }
            />
          </Route>
          <Route path="contract">
            <Route path="upload">
              <Route
                index
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.CONTRACT}>
                    <EmployeeContract />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="edit/:id"
              element={
                <ProtectedRoute requiredMenus={MENU_ID.CONTRACT}>
                  <EditEmployeeContract />
                </ProtectedRoute>
              }
            />
            <Route
              path="create"
              element={
                <ProtectedRoute requiredMenus={MENU_ID.CONTRACT}>
                  <AddEmployeeContract />
                </ProtectedRoute>
              }
            />
          </Route>

          {/*----------------------------------- Support - Master Data --------------------------*/}
          <Route path="masterdata">
            <Route index element={<Navigate to="users" replace />} />
            <Route path="users">
              <Route
                index
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.USERS}>
                    <Users />
                  </ProtectedRoute>
                }
              />
              <Route
                path="edit/:id"
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.USERS}>
                    <EditUser />
                  </ProtectedRoute>
                }
              />
              <Route
                path="editEmp/:id"
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.USERS}>
                    <EditEmp />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.USERS}>
                    <CreateUser />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="roles">
              <Route
                index
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.ROLES}>
                    <Roles />
                  </ProtectedRoute>
                }
              />
              <Route
                path="edit/:id"
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.ROLES}>
                    <EditRole />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.ROLES}>
                    <CreateRole />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="status">
              <Route
                index
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.STATUS}>
                    <Status />
                  </ProtectedRoute>
                }
              />
              <Route
                path="edit/:id"
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.STATUS}>
                    <EditStatus />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="sites">
              <Route
                index
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.SITES}>
                    <Sites />
                  </ProtectedRoute>
                }
              />
              <Route
                path="edit/:id"
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.SITES}>
                    <EditSite />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.SITES}>
                    <CreateSite />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="menus">
              <Route
                index
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.SITES}>
                    <Menus />
                  </ProtectedRoute>
                }
              />
              <Route
                path="edit/:id"
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.SITES}>
                    <ManageMenu type="edit" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.SITES}>
                    <ManageMenu type="add" />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="bank">
              <Route
                index
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.Bank}>
                    <Bank />
                  </ProtectedRoute>
                }
              />
              <Route
                path="edit/:id"
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.Bank}>
                    <ManageBank type="edit" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.Bank}>
                    <ManageBank type="add" />
                  </ProtectedRoute>
                }
              />
            </Route>

            {/* <Route path="bank" element={<Bank />} /> */}
            <Route path="bank">
              <Route
                index
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.Bank}>
                    <Bank />
                  </ProtectedRoute>
                }
              />
              <Route
                path="edit/:id"
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.Bank}>
                    <ManageBank type="edit" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.Bank}>
                    <ManageBank type="add" />
                  </ProtectedRoute>
                }
              />
            </Route>
            {/* company */}
            <Route path="company">
              <Route
                index
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.COMPANY}>
                    <Company />
                  </ProtectedRoute>
                }
              />
              <Route
                path="edit/:id"
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.COMPANY}>
                    <ManageCompany type="edit" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute requiredMenus={MENU_ID.COMPANY}>
                    <ManageCompany type="add" />
                  </ProtectedRoute>
                }
              />
            </Route>
            {/* country */}
            <Route path="country">
              <Route
                index
                element={
                  <ProtectedRoute>
                    <Country />
                  </ProtectedRoute>
                }
              />
              <Route
                path="edit/:id"
                element={
                  <ProtectedRoute>
                    <ManageCountry type="edit" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute>
                    <ManageCountry type="add" />
                  </ProtectedRoute>
                }
              />
            </Route>
            {/* CountryOfNationalId */}
            <Route path="country-national">
              <Route
                index
                element={
                  <ProtectedRoute>
                    <CountryOfNationalId />
                  </ProtectedRoute>
                }
              />
              <Route
                path="edit/:id"
                element={
                  <ProtectedRoute>
                    <ManageCountryOfNationalId type="edit" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute>
                    <ManageCountryOfNationalId type="add" />
                  </ProtectedRoute>
                }
              />
            </Route>
            {/* religion */}
            <Route path="religion">
              <Route
                index
                element={
                  <ProtectedRoute>
                    <Religion />
                  </ProtectedRoute>
                }
              />
              <Route
                path="edit/:id"
                element={
                  <ProtectedRoute>
                    <ManageReligion type="edit" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute>
                    <ManageReligion type="add" />
                  </ProtectedRoute>
                }
              />
            </Route>
            {/* MaritalStatus */}
            <Route path="marital-status">
              <Route
                index
                element={
                  <ProtectedRoute>
                    <MaritalStatus />
                  </ProtectedRoute>
                }
              />
              <Route
                path="edit/:id"
                element={
                  <ProtectedRoute>
                    <ManageMaritalStatus type="edit" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute>
                    <ManageMaritalStatus type="add" />
                  </ProtectedRoute>
                }
              />
            </Route>
            {/* Prefix */}
            <Route path="prefix">
              <Route
                index
                element={
                  <ProtectedRoute>
                    <Prefix />
                  </ProtectedRoute>
                }
              />
              <Route
                path="edit/:id"
                element={
                  <ProtectedRoute>
                    <ManagePrefix type="edit" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute>
                    <ManagePrefix type="add" />
                  </ProtectedRoute>
                }
              />
            </Route>
            {/* incentive-group */}
            <Route path="incentive-group">
              <Route
                index
                element={
                  <ProtectedRoute>
                    <IncentiveGroup />
                  </ProtectedRoute>
                }
              />
              <Route
                path="edit/:id"
                element={
                  <ProtectedRoute>
                    <ManageIncentiveGroup type="edit" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute>
                    <ManageIncentiveGroup type="add" />
                  </ProtectedRoute>
                }
              />
            </Route>
            {/* ONB-Holiday-Schedule */}
            <Route path="holiday-schedule">
              <Route
                index
                element={
                  <ProtectedRoute>
                    <ONBHolidaySchedule />
                  </ProtectedRoute>
                }
              />
              <Route
                path="edit/:id"
                element={
                  <ProtectedRoute>
                    <ManageONBHolidaySchedule type="edit" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute>
                    <ManageONBHolidaySchedule type="add" />
                  </ProtectedRoute>
                }
              />
            </Route>
            {/* work-schedule */}
            <Route path="work-schedule">
              <Route
                index
                element={
                  <ProtectedRoute>
                    <ONBSchedule />
                  </ProtectedRoute>
                }
              />
              <Route
                path="edit/:id"
                element={
                  <ProtectedRoute>
                    <ManageONBSchedule type="edit" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute>
                    <ManageONBSchedule type="add" />
                  </ProtectedRoute>
                }
              />
            </Route>
            {/* PayGrade */}
            <Route path="pay-grades">
              <Route
                index
                element={
                  <ProtectedRoute>
                    <PayGrade />
                  </ProtectedRoute>
                }
              />
              <Route
                path="edit/:id"
                element={
                  <ProtectedRoute>
                    <ManagePayGrade type="edit" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute>
                    <ManagePayGrade type="add" />
                  </ProtectedRoute>
                }
              />
            </Route>
            {/* pay-groups */}
            <Route path="pay-groups">
              <Route
                index
                element={
                  <ProtectedRoute>
                    <PayGroup />
                  </ProtectedRoute>
                }
              />
              <Route
                path="edit/:id"
                element={
                  <ProtectedRoute>
                    <ManagePayGroup type="edit" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute>
                    <ManagePayGroup type="add" />
                  </ProtectedRoute>
                }
              />
            </Route>
            {/* SSO-Hospital */}
            <Route path="sso-Hospital">
              <Route
                index
                element={
                  <ProtectedRoute>
                    <SSOHospital />
                  </ProtectedRoute>
                }
              />
              <Route
                path="edit/:id"
                element={
                  <ProtectedRoute>
                    <ManageSSOHospital type="edit" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute>
                    <ManageSSOHospital type="add" />
                  </ProtectedRoute>
                }
              />
            </Route>
            {/* work-groups */}
            <Route path="work-groups">
              <Route
                index
                element={
                  <ProtectedRoute>
                    <WorkGroup />
                  </ProtectedRoute>
                }
              />
              <Route
                path="edit/:id"
                element={
                  <ProtectedRoute>
                    <ManageWorkGroup type="edit" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create"
                element={
                  <ProtectedRoute>
                    <ManageWorkGroup type="add" />
                  </ProtectedRoute>
                }
              />
            </Route>
            {/* otp */}
            <Route path="otp">
              <Route
                index
                element={
                  <ProtectedRoute>
                    <OTP />
                  </ProtectedRoute>
                }
              />
            </Route>

            <Route path="excel-to-ec" element={<ExcelToECPagingSupport />} />
            <Route path="data-ec" element={<DataToECPagingSupport />} />
            {/* <Route path="data-to-ec" element={<DataToECPagingSupport />} /> */}
          </Route>
        </Route>

        <Route path="/login/AADRedirect" element={<LoginRedirectPage />} />

        <Route path="/forbidden" element={<ForbiddenError />} />
        <Route path="/system-maintenance" element={<SystemMaintenance />} />
        <Route path="/unauthorized" element={<UnauthorizedError />} />
        <Route path="/servererror" element={<InternalServerError />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Fragment>
  )
}

export default App
